import {
  IonButton,
  IonButtons,
  IonCard,
  IonIcon,
  IonInput,
  IonItem,
  IonReorder,
  IonSelect,
  IonSelectOption,
  useIonToast,
} from "@ionic/react";
import { menuOutline, trashOutline } from "ionicons/icons";
import { useDispatch } from "react-redux";
import { TemplateQuestion } from "../../../@types/templateQuestion";
import { removeFromList, setQuestionLabel, setQuestionType } from "../../../store/templateDetail";
import { removeQuestionFromList } from "../../../store/templateDetail/actions/removeQuestionFromList";

interface Props {
  index: number;
  question: TemplateQuestion;
}

export const TemplateInputItem: React.FC<Props> = ({ index, question }) => {
  const dispatch = useDispatch();
  const [presentToast, hideToast] = useIonToast();

  const handleDelete = async (id: number, order: number) => {
    try {
      if (id) {
        presentToast({
          message: `Eliminando pregunta...`,
          color: "primary",
        });
        const { payload }: any = await dispatch(removeQuestionFromList({ id: id, order: order }));

        if (!payload) {
          throw new Error("No se eliminó la pregunta.");
        }
        await hideToast();
        presentToast({
          message: `Se eliminó la pregunta.`,
          color: "success",
          duration: 2000,
        });
      } else {
        dispatch(removeFromList(order));
      }
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema eliminando la pregunta.",
        color: "danger",
        duration: 2000,
      });
    }
  };

  return (
    <IonCard key={index}>
      <IonItem>
        {question.type === "text" &&
          <IonInput
            type="text"
            placeholder="Pregunta sin titulo"
            style={{ width: "75%" }}
            value={question.label}
            onIonChange={({ detail: { value } }) =>
              dispatch(setQuestionLabel({ order: question.order, label: value! }))
            }
          />
        }
        {question.type === "user" &&
          <IonInput
            type="text"
            placeholder="Pregunta sin titulo"
            style={{ width: "75%" }}
            value={question.label}
            onIonChange={({ detail: { value } }) =>
              dispatch(setQuestionLabel({ order: question.order, label: value! }))
            }
          />
        }

        <IonSelect
          style={{ width: "25%" }}
          value={question.type}
          onIonChange={({ detail: { value } }) =>
            dispatch(setQuestionType({ order: question.order, type: value! }))
          }
          placeholder="Seleccione tipo..."
        >
          <IonSelectOption value="text">Texto</IonSelectOption>
          <IonSelectOption value="user">Usuario</IonSelectOption>
        </IonSelect>
      </IonItem>
      <IonItem>
        {question.type === "text" &&
          <IonInput
            type="text"
            placeholder={"Ejemplo texto..."}
            readonly
            style={{ width: "50%" }}
          />
        }
        {question.type === "user" &&
          <IonInput
            type="text"
            placeholder={"Ej. John Doe"}
            readonly
            style={{ width: "50%" }}
          />
        }
        <IonButtons style={{ width: "10%" }}>
          <IonButton color="danger" onClick={() => handleDelete(question.id!, question.order)}>
            <IonIcon icon={trashOutline} />
          </IonButton>
        </IonButtons>
        <IonReorder>
          <IonIcon icon={menuOutline} />
        </IonReorder>
      </IonItem>
    </IonCard>
  );
};
